module.exports = __webpack_public_path__ + "img/dog-exercise.1ecf6719.png";